/**
 * Admin queue — /admin/queue (route shell).
 *
 * Screen impl in `./queue-screen.tsx`, lazy-loaded. Admin-gated surface (behind
 * the /admin layout) — never on a trustee's path, so it stays out of the
 * initial bundle.
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/queue')({
  component: lazyRouteComponent(() => import('./queue-screen'), 'AdminQueuePage'),
});
